export default "__VITE_ASSET__71040d35__"